import React from 'react'

export interface ReviewThankYouProps {
  status: 'published' | 'submitted'
  supplierName: string
  contractName: string | null
  supplierProfileUrl: string | null
}

export const ReviewThankYou: React.FC<ReviewThankYouProps> = ({ status, supplierName, contractName, supplierProfileUrl }) => {
  return (
    <>
      {status === 'published' && (
        <p>Your feedback has been published! Visit the supplier’s profile to view it.</p>
      )}
      {status === 'submitted' && (
        <>
          <p>
            We're processing your review for <b>{supplierName}</b>
            {contractName != null && <> and <b>{contractName}</b></>}. We will send you a confirmation email when it is posted.
          </p>
          <p>Once your review has been verified, it will be published on Procurated where authorized users can read it.</p>
          <p>
            You can <a href='/#authenticate'>login</a> to Procurated to view your published reviews and those written by your peers.
          </p>
        </>
      )}
      {supplierProfileUrl != null && (
        <div className='supplier-profile-link'>
          <a href={supplierProfileUrl} id='view-supplier-profile' className='button small-only-expanded'>
            View Supplier Profile
          </a>
        </div>
      )}
    </>
  )
}
